import m from "../../geodata/es2015/moldovaLow";
window.am4geodata_moldovaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/moldovaLow.js
// module id = null
// module chunks = 